export default {
	styleOverrides: {
		root: ({ theme }) => ({
			'.MuiDataGrid-virtualScrollerRenderZone .MuiDataGrid-row': {
				'&:nth-of-type(odd) .MuiDataGrid-cell': {
					backgroundColor: theme.palette.background.eveCustom.secondary,
				},
				'&:hover .MuiDataGrid-cell, &.Mui-hovered .MuiDataGrid-cell': {
					backgroundColor: theme.palette.secondary.light,
				},
			},
			'.MuiDataGrid-columnHeaders': {
				backgroundColor: theme.palette.primary.dark,
				color: theme.palette.primary.contrastText,
				'.MuiDataGrid-columnHeader, .MuiDataGrid-filler': {
					backgroundColor: theme.palette.primary.dark,
				},
				// Hide the icon separator that is rendered after the rightmost header cell
				'.MuiDataGrid-columnHeader:last-child .MuiDataGrid-iconSeparator': {
					display: 'none',
				},
				'.MuiDataGrid-iconSeparator': {
					color: theme.palette.primary.contrastText,
				},
			},
			'.MuiDataGrid-menuIconButton': {
				color: theme.palette.primary.contrastText,
			},
			'.MuiDataGrid-sortIcon': {
				color: theme.palette.primary.contrastText,
			},
		}),
	},
};
